import { z } from 'zod';
/**
 * Money and the numbers that behave like money (plan §5.8). JOD is stored as `numeric(14, 3)` and every
 * amount that crosses the API is a plain number rounded to three decimals — the engine does the exact
 * `decimal.js` arithmetic, the contract only states the shape.
 */
export const MONEY_SCALE = 3;
/** The smallest JOD unit the system records: 0.001. */
export const MONEY_STEP = 0.001;
export const MAX_AMOUNT = 99_999_999.999;
/** A price, a cost, a deduction — never negative. Use `signedMoneySchema` for differences. */
export const amountSchema = z.number().finite().nonnegative().max(MAX_AMOUNT);
/** A difference between two amounts: offer − ceiling, sale − required retail. May be negative. */
export const signedMoneySchema = z.number().finite().min(-MAX_AMOUNT).max(MAX_AMOUNT);
/** Percentages are stored as fractions everywhere; only the UI converts to `%` (plan §11.6). */
export const fractionSchema = z.number().finite().min(0).max(1);
/** A calendar date with no time part — `valuation_date`, `purchase_date`, `sale_date`. */
export const isoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Enter a date as YYYY-MM-DD');
/** Optimistic-concurrency token carried by every `[rev]` mutation (plan §2.3). */
export const revisionSchema = z.number().int().min(1);
//# sourceMappingURL=money.schemas.js.map